import React, { useContext, useEffect, useState } from "react";
// React Bootstrap
import { Accordion, Card, Button, Container } from "react-bootstrap";
// Componentes
import VistaEconomicos from "../vistas/VistaEconomicos";
import FormEconomicos from "../formularios/FormEconomicos";
// Contexto
import { ModalContext } from "../../../../context/modalContext";
// jquery
import $ from "jquery";

const Economicos = ({ idProvincia, idMision, datosMision, handlePutDatosMision }) => {
  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);
  // Datos de ingresos de la misión
  const [datosIngresos, setDatosIngresos] = useState([]);

  useEffect(() => {
    datosMision.type === "Obra" && handleGetDatosIngresos();
  }, []);

  // Obtiene los datos de ingresos de la obra
  const getDatosIngresos = () => {
    let settings = {
      url: `${process.env.REACT_APP_API_URL}/provincias/${idProvincia}/misiones/${idMision}/ingresos`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Edita los datos de ingresos de una misión
  const postDatosIngresos = (data) => {
    let settings = {
      url: process.env.REACT_APP_API_URL + `/provincias/${idProvincia}/misiones/${idMision}/ingresos`,
      method: "POST",
      contentType: "application/json; charset=utf-8",

      xhrFields: {
        withCredentials: true,
      },
      data: JSON.stringify(data),
    };
    return $.ajax(settings);
  };

  // Manejador para obtener los datos de la misión de los ingresos
  const handleGetDatosIngresos = () => {
    getDatosIngresos()
      .then((response) => {
        setDatosIngresos(response.items);
      })
      .catch(() => {
        // props?.ErrorHandling();
      });
  };

  // Manejador para el put de los datos de ingresos y de una mision
  const handlePostDatosIngresos = (data) => {
    // Hacemos el put para los ingresos si es una obra
    if (datosMision.type === "Obra") {
      postDatosIngresos(data.objIngresos)
        .then(() => {
          // TODO no volver a pedir los datos sino gestionar el estado sin volver a pedir.
          handleGetDatosIngresos();
        })
        .catch(() => {
          // props?.ErrorHandling();
        });
    }
    // Hacemos un put con los datos
    handlePutDatosMision(data);
  };

  return (
    <Accordion defaultActiveKey="0">
      <Card>
        <Card.Header>
          <Accordion.Toggle eventKey="0" as={Button} variant="link">
            Datos económicos
          </Accordion.Toggle>
          <Button
            variant="outline-primary"
            size="sm"
            className="float-right mr-4"
            onClick={() => {
              modalSetShow(true, "80%");
              modalSetTitle("Editar datos económicos de la misión");
              modalSetContent(<FormEconomicos defaultValues={{ ...datosMision, datosIngresos }} submissionHandler={handlePostDatosIngresos} />);
            }}
          >
            Editar
          </Button>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body className={"bg-light"}>
            <VistaEconomicos datosMision={datosMision} datosIngresos={datosIngresos} />
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};

export default Economicos;
